import { Group } from "@mantine/core";
import { IncrementalDateInput } from "@ots-frontend/ots-ui";

export type DispatchRequestTool = ""

type DispatchRequestToolbarProps = {
  date: Date
  onDateChange: (d: Date) => void
  onToolSelect?: (tool: DispatchRequestTool) => void
}

export const DispatchRequestToolbar = (props: DispatchRequestToolbarProps) => {
  const { date, onDateChange, onToolSelect } = props;

  return (
    <Group position="apart" p="xs">
      <Group position="center">

      </Group>
      <Group position="center">
        <IncrementalDateInput defaultValue={date} onDateChange={onDateChange} />
      </Group>
      <Group position="center">

      </Group>
    </Group>
  );
};
